import {
  Activity,
  AlertCircle,
  Archive,
  Award,
  BarChart3,
  Bell,
  BookOpen,
  Bookmark,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Camera,
  Cloud,
  Code,
  Coffee,
  Compass,
  CreditCard,
  Database,
  Factory,
  FileText,
  Film,
  Flag,
  FolderOpen,
  Gift,
  Globe,
  Globe2,
  Hammer,
  Headphones,
  Heart,
  Home,
  Image,
  Inbox,
  Info,
  Key,
  Landmark,
  Laptop,
  Layers,
  Leaf,
  Library,
  Link,
  Lock,
  type LucideIcon,
  Mail,
  Map as MapIcon,
  MessageCircle,
  Mic,
  Monitor,
  Music,
  Network,
  Newspaper,
  Package,
  Palette,
  Phone,
  PieChart,
  Plane,
  Printer,
  Rocket,
  ScrollText,
  Search,
  Server,
  Settings,
  Share2,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Speaker,
  Star,
  Store,
  Tag,
  Target,
  TrendingUp,
  Trophy,
  Truck,
  Tv,
  University,
  User,
  Users,
  Video,
  Wallet,
  Wrench,
  Youtube,
  Zap,
} from 'lucide-react';

/**
 * 패밀리 사이트 로고로 선택 가능한 lucide icon 화이트리스트.
 * Key 는 lucide-react 의 export 이름 그대로 DB 에 저장.
 * 새 아이콘 추가 시 import 만 추가하면 picker 와 사이드바 렌더러 양쪽에 반영.
 */
export const FAMILY_SITE_LUCIDE_ICONS: Record<string, LucideIcon> = {
  Activity,
  AlertCircle,
  Archive,
  Award,
  BarChart3,
  Bell,
  Bookmark,
  BookOpen,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Camera,
  Cloud,
  Code,
  Coffee,
  Compass,
  CreditCard,
  Database,
  Factory,
  FileText,
  Film,
  Flag,
  FolderOpen,
  Gift,
  Globe,
  Globe2,
  Hammer,
  Headphones,
  Heart,
  Home,
  Image,
  Inbox,
  Info,
  Key,
  Landmark,
  Laptop,
  Layers,
  Leaf,
  Library,
  Link,
  Lock,
  Mail,
  Map: MapIcon,
  MessageCircle,
  Mic,
  Monitor,
  Music,
  Network,
  Newspaper,
  Package,
  Palette,
  Phone,
  PieChart,
  Plane,
  Printer,
  Rocket,
  ScrollText,
  Search,
  Server,
  Settings,
  Share2,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Speaker,
  Star,
  Store,
  Tag,
  Target,
  TrendingUp,
  Trophy,
  Truck,
  Tv,
  University,
  User,
  Users,
  Video,
  Wallet,
  Wrench,
  Youtube,
  Zap,
};

export const FAMILY_SITE_LUCIDE_NAMES = Object.keys(FAMILY_SITE_LUCIDE_ICONS).sort();

export function getFamilySiteLucideIcon(name: string | null | undefined): LucideIcon | null {
  if (!name) return null;
  return FAMILY_SITE_LUCIDE_ICONS[name] ?? null;
}

export const FAMILY_SITE_EMOJI_SUGGESTIONS = [
  '🏢',
  '🏭',
  '🏛️',
  '🌐',
  '🌍',
  '📊',
  '📈',
  '📁',
  '📂',
  '💼',
  '🛒',
  '📚',
  '📰',
  '⚙️',
  '🔧',
  '🛠️',
  '💡',
  '✨',
  '🚀',
  '🎯',
  '📝',
  '📞',
  '📧',
  '🗂️',
  '🔒',
  '🔑',
  '🎨',
  '🎬',
  '🎵',
  '☁️',
];
